import { Spinner } from '@fuegokit/react';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  min-height: 110px;
`;

export function LoadingPage() {
  return (
    <Center>
      <Spinner aria-label={`Loading…`} size="large" />
    </Center>
  );
}
